/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate ,useLocation, useSearchParams } from "react-router-dom";
import Button from '@mui/material/Button';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

function ResponseRegisterPage() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center bg-[#68B2A0] min-h-screen">
      <div className=" md:w-[480px] md:min-h-[400px]  font-light  bg-white rounded-3xl">
        <div className='p-10'> 
          <div className=" flex justify-center">
            <CheckCircleOutlineIcon sx={{fontSize:120,color:'#68B2A0'}} />
          </div>
          <div className=" flex justify-center mt-4 font-medium text-3xl text-gray-600">Success</div>
          <div className='flex justify-center mt-2  text-gray-400 font-medium'>
               รับการแจ้งเตือนใน Line สำเร็จ
          </div>
         <div className='flex justify-center mt-12' >
         <Button onClick={()=>{
          navigate('/setting')
         }} variant="contained" sx={{color:'#fff',backgroundColor:'#68B2A0'}}>กลับสู่หน้าบัญชีผู้ใช้</Button>
         </div>
         {/* <div className=" flex justify-center">
            <HighlightOffIcon sx={{fontSize:120,color:'#B33030'}} />
          </div>
          <div className=" flex justify-center mt-4 font-medium text-3xl text-gray-600">Fail</div>
          <div className='flex justify-center mt-2  text-gray-400 font-medium'>
               รับการแจ้งเตือนใน Line ไม่สำเร็จ
          </div>
         <div className='flex justify-center mt-12' >
         <Button variant="contained" sx={{color:'#fff',backgroundColor:'#68B2A0'}}>กลับสู่หน้าหลัก</Button>
         </div> */}
        </div>
      </div>
    </div>
  );
}

export default ResponseRegisterPage;
